import React, { FC } from "react";
import styled from "styled-components";

import { formatSnakeCaseOrCamelCase } from "@formant/core/common/formatSnakeCaseOrCamelCase";
import { primary } from "@formant/ui/component/common/Colors";
import { Typography } from "@formant/ui/component/common/Typography";

import { useStores } from "../../context/StoreContext";
import { StandardButton } from "../common/StandardButton";
import {
    getArrayValue,
    getFirstArrayFieldValue,
} from "./JsonSchemaArrayOfObjects";
import { IInputProps } from "./types";
import { updatePath } from "./updatePath";

export const DeleteArrayItemButton: FC<IInputProps> = props => {
    const { params, setParams, currentPath, setCurrentPath } = props;

    const { appStore } = useStores();

    const handleClick = () => {
        // currently, the current path is in the index of an array
        // example: base/cookies/[0]
        // so we do two things:
        // 1. alter the array list (cookies) by removing the current index
        // 2. Send the current path back to base because arrays don't have a window.
        const arrayPath = currentPath.slice(0, currentPath.length - 1);
        const lastPrevValue = [...arrayPath].pop();
        const lastPathValue = [...currentPath].pop();
        const preview = getFirstArrayFieldValue(
            getArrayValue(params, currentPath),
            "this item",
        );
        appStore.setConfirm({
            title: "Delete Item",
            message: (
                <Typography type="body">
                    {`Delete `}
                    <Typography type="body" color="white">
                        {preview}
                    </Typography>
                    {` from ${formatSnakeCaseOrCamelCase(
                        lastPrevValue || "the list",
                    ).toLocaleLowerCase()}?`}
                </Typography>
            ),
            critical: true,
            okCopy: "Delete",
            onOk: () => {
                setParams(prev =>
                    updatePath(
                        prev,
                        arrayPath,
                        getArrayValue(params, arrayPath).filter(
                            (_, index) =>
                                String(index) !== String(lastPathValue),
                        ),
                    ),
                );
                setCurrentPath(currentPath.slice(0, currentPath.length - 2));
            },
        });
    };

    return <DeleteButton onClick={handleClick}>Delete</DeleteButton>;
};

export const isCurrentPathAnArrayIndex = (currentPath: string[]) => {
    return !isNaN(parseInt([...currentPath].pop() || "not a number", 10));
};

const DeleteButton = styled(StandardButton)`
    margin-top: 1.25rem;
    margin-left: 1.5rem;
    background: ${primary.steel02};
    width: 19.5rem;
    color: ${primary.silver};
    margin-bottom: 0.5rem;
`;
